import api from "../client.ts";

export type PaiementType = {
  id: number;
  montant: number;
  operation_id: string;
  motif_paiement_id: number;
  eleve_id: number;
  personnel_id: number;
  annee_scolaire_id: number;
  terminal_id: number;
  jour: string; // Format date-heure en string
  status: number;
  created_at: string;
  updated_at: string | null;
};


export type MontantType = {
  id: number;
  montant: number;  // Amount (could be float, depending on your needs)
  classe_id: number;
  annee_scolaire_id: number;
  status: number;
  created_at: string;  // ISO date-time string
  updated_at: string;  // ISO date-time string
}

//Paiement
const getAll = async ():Promise<{size:number,data: PaiementType[]}> => {
  const { data } = await api.get("/paiement/readAll");
  return data;
};
const create = async (newRecord:any) => {
  const { data } = await api.post("/paiement/create",newRecord);
  return data;
};
const update = async (id:any, newRecord:any) => {
  const { data } = await api.put(`/paiement/update?id=${id}`, newRecord);
  return data;
};
const desactivate = async (id:any) => {
  const { data } = await api.get(`/paiement/desactive?id=${id}`);
  return data;
};


export const paymentController = {getAll,create, update, desactivate}
